/* Helper to send page views to both Google Analytics and Google Tag Manager */
export const sendPageView = (path, fieldsObject = {}) => {
    const { title } = fieldsObject;
    const pageTitle = title || document.title;

    // Send to Google Analytics
    if (typeof window.ga === "function") {
        ga("send", "pageview", path, pageTitle);
    }

    // Send to Google Tag Manager
    window.dataLayer.push({
        event: "pageview",
        pagePath: path,
        pageTitle: pageTitle
    });
};

/* Helper to send events to both Google Analytics and Google Tag Manager */
export const sendEvent = (category, action, label, value) => {
    // Send to Google Analytics
    if (typeof window.ga === "function") {
        ga("send", "event", category, action, label, value);
    }

    // Send to Google Tag Manager
    window.dataLayer.push({
        event: "event",
        category: category,
        action: action,
        label: label,
        value: value
    });
};

/* Helper to send events to both Google Analytics and Google Tag Manager */
export const setAccountType = accountType => {
    // Send to Google Analytics
    if (typeof window.ga === "function") {
        ga("set", "dimension1", accountType);
    }

    // Send to Google Tag Manager
    window.dataLayer.push({ accountType: accountType });
};
